// extracted by mini-css-extract-plugin
module.exports = {"container":"VariantForm_container__WyJMh","form":"VariantForm_form__OWdpE","tooltip":"VariantForm_tooltip__3g3wO"};